import Api from '@/services/api';

import {
	CreateBeraReportV2Request,
	DeleteBeraReportV2Request,
	BeraReportsV2ListRequest,
	UpdateBeraJobSummaryFileRequest,
	UpdateBeraReportSegmentsRequest,
	UpdateAllBeraReportSegmentsRequest
} from '@/components/views/BeraJob/hooks/types/request';
import {
	BeraReportV2DTO,
	BeraReportsV2ListDTO,
	UpdateBeraJobSummaryFileDTO
} from '@/components/views/BeraJob/hooks/types/response';

export class BeraReportV2Service {
	async listBeraReportsByJobSummary({
		bera_job_summary_id,
		...params
	}: BeraReportsV2ListRequest): Promise<BeraReportsV2ListDTO> {
		const query = new URLSearchParams({
			organization_id: params.organization_id,
			company_id: params.company_id,
			limit: String(params.limit),
			offset: String(params.offset),
			only_not_evaluated: String(params.only_not_evaluated),
			task_name: params.task_name ?? ''
		});
		const url = `/bera/v2/job-summary/${bera_job_summary_id}/reports?${query.toString()}`;
		const { data } = await Api.get<BeraReportsV2ListDTO>(url);
		return data;
	}

	async updateBeraJobSummaryFile({
		bera_job_summary_id,
		...body
	}: UpdateBeraJobSummaryFileRequest): Promise<UpdateBeraJobSummaryFileDTO> {
		const url = `/bera/v2/job-summary/${bera_job_summary_id}/file`;
		const { data } = await Api.put<UpdateBeraJobSummaryFileDTO>(url, body);
		return data;
	}

	async createBeraReport(body: CreateBeraReportV2Request): Promise<BeraReportV2DTO> {
		const url = '/bera/v2/report';
		const { data } = await Api.post<BeraReportV2DTO>(url, body);
		return data;
	}

	async updateBeraReportSegments(body: UpdateBeraReportSegmentsRequest): Promise<BeraReportV2DTO> {
		const url = `/bera/v2/report/${body.bera_report_id}/segments`;
		const { data } = await Api.patch<BeraReportV2DTO>(url, body);
		return data;
	}

	async updateAllBeraReportSegments({
		bera_job_summary_id,
		...body
	}: UpdateAllBeraReportSegmentsRequest): Promise<BeraReportV2DTO[]> {
		const url = `/bera/v2/job-summary/${bera_job_summary_id}/segments`;
		const { data } = await Api.put<BeraReportV2DTO[]>(url, body);
		return data;
	}

	async deleteBeraReport({ organization_id, company_id, bera_report_id }: DeleteBeraReportV2Request): Promise<void> {
		const url = `/bera/v2/report/${bera_report_id}?organization_id=${organization_id}&company_id=${company_id}`;
		await Api.delete(url);
	}
}
